import '../../../../node_modules/prosemirror-transform/dist/index.es.js';
import '../../../../node_modules/prosemirror-state/dist/index.es.js';
import '../../../../node_modules/prosemirror-commands/dist/index.es.js';
import { Node } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { listItem } from '../../../../node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/list-item.js';
import { splitListItem, sinkListItem, liftListItem } from '../../../../node_modules/prosemirror-schema-list/dist/index.es.js';
import '../../../../node_modules/tiptap-commands/node_modules/prosemirror-model/dist/index.es.js';
import '../../../../node_modules/prosemirror-utils/dist/index.js';

/* eslint-disable */
class ListItem extends Node {
  get name() {
    return 'listItem';
  }

  get schema() {
    return listItem;
  }

  keys({
    type
  }) {
    return {
      Enter: splitListItem(type),
      Tab: sinkListItem(type),
      'Shift-Tab': liftListItem(type)
    };
  }

}

export default ListItem;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/nodes/ListItem.js